const releaseNotes = [
  {
    version: "V3.1 Pre Release 1",
    date: "November 26, 2025",
    sections: {
      "New Features": [
        "Added the weird card game I was talking about before!",
        "This is a super alpha phase where I just want anyone to play around with it and see if they like it or not.",
        "The card template is made by Sugar which looks amazing!",
        "One thing to note is that 99% of cards are AI images however I do want to have someone in the community or allow community cards into this game as right now I just spun a wheel with a bunch of random things on it lol. I did not want to spend hours drawing all the cards and I even back down from my original amount of cards I wanted to add. So please let me know on this as I already implemented a system to even credit artist if they make a card! (I did make 2 cards too!)",
        "/cards - Where you can view all the cards you own",
        "/cardshop - Where you can buy new cards or get a free daily card pack!",
        "/cardteam - Where you can create a team up to 5 cards to go to battle!",
        "/cardbattle - Where you can battle enemies for card fragments every 2 hours!",
      ],
      "Changes": [
        "The old /card is renamed to /randomcard. I was going to remove this command but I am going to leave it for now.",
      ],
      "Bug Fixes": [
        "Finally fixed the server count lol! I spent how many years on this and a dumb idea became the best solution...",
        "A few commands got some cleanup but nothing crazy!"
      ]
    }
  },
  {
    version: "V3.0 Pre Release 5",
    date: "September 30, 2025",
    sections: {
      "Massive Changes": [
        "/setting - Added a setting command which allows users to change their weather information to metric or imperial!",
        "A requested feature that been asked for over 3+ years which was complicated due to how the weather command used to be but now is very easy and possible but also should have came out like 4 months ago lol...",
      ],
      "Bug Fixes": [
        "/rps - Added emojis so you can easily tell what item you used (I believe I had this before but then it got removed...)",
        "DMAI - Fixed a weird bug where direct messages to Useless Bot makes the Useless Bot Is Typing disappear too early",
        "/ai speech - Fixed it and should be working now!"
      ],
      "Broken Stuff": [
        "/ai search - is now deprecated as my AI provides also removed it."
      ]
    }
  },
  {
    version: "V3.0 Pre Release 4",
    date: "June 9, 2025",
    sections: {
      "Newest Feature": [
        "This is something that I believe 50% will love and 50% will hate but I believe this can become super helpful and amazing for everyone!",
        "You can now DM Useless Bot and have Ucy AI talk to you!!!!",
        "WOO or BOO but wait isnt this just /ai chat? Nope it has a completely different model and system and it even remembers your past messages! We do not store your messages as Useless Bot can easily fetch your last messages from your DM! Thanks Discord! Good for me as I don't have enough storage to hold this data anyways and good for you as this is privacy!",
        "Now there will be a bunch of bugs and issues as this runs from a completely different system and will be a pain to fix. So if you find any please let me know and I'll try to fix it!",
        "I believe this feature can help many users as I have worked on something similar elsewhere that has helped tons of users! I have more features planned too!",
      ],
      "New Command": [
        "/blackjack - A new command where you can play Blackjack!"
      ],
      "Other Stuff": [
        "/poll - Now has more options and you can use multiple emojis (need to work on examples)",
        "/leaderboard - Fixed a small comma bug fix"
      ]
    }
  },
  {
    version: "V3.0 Pre Release 3",
    date: "May 20, 2025",
    sections: {
      "Big Changes": [
        "/upgrade - now has over 30+ new upgrades for all your shops!!! (I wanted to make some of them funny but I only think that 1 of them are). Also upgrades will no longer show the upgrades that you already bought!"
      ],
      "Bug Fixes": [
        "Fixed leaderboard not being in order",
        "Fixed rounding issue in daily and work",
        "Fixed 4 commands with Crash potential!"
      ]
    }
  },
  {
    version: "V3.0 Pre Release 2",
    date: "May 13, 2025",
    sections: {
      "New": [
        "/ai search (message) - now Ucy AI has access to the internet with the help of OpenAI ChatGPT newest search model!",
        "/upgrade (upgrade) - we added upgrades!!!!! Now economy players can upgrade their shops to make them cheaper or more profitable!!!! There are currently 4 for now and will be add more slowly! Current plan is to have at least 2 upgrades for every shop!"
      ],
      "Smaller Things": [
        "Weather command has time fixed for hourly and also added weather emojis to make the UI look nicer!",
        "Leaderboard has an Xp leaderboard now. Xp is kinda useless right now even though we been having it for years now but I guess this will do for now...",
        "Help command has a link to Useless Bot's website where you can view all the commands there as well!"
      ],
      "Bug Fixes": [
        "Xp was not being given to players that use commands",
        "Ping logging issue (only affected me lol)",
        "Some link buttons were wrong...",
        "There are more which I did not write down..."
      ]

    }
  },
  {
    version: "V3.0 Pre Release 1",
    date: "April 29, 2025",
    sections: {
      "Massive Changes": [
        "Achievement System! You can now get achievement for using commands! Currently 4 but more to come!",
        "Voting for Useless Bot is automatically dectected",
        "New economy system to allow better shops and new things in the future (sadly everyone progress have been deleted but now it is easier to catch up!)",
        "/ai chat now uses OpenAI's ChatGPT model 40",
        "/ai speech a new command that is like /ai chat but uses OpenAI's voice models to speak instead of reading! (Good for bedtime stories)",
        "/slots now has animations!",
        "/weather has nicer interface for premium users (free users still has some work left to do...)"
      ],
      "Big Changes": [
        "/code now has encode and decode options to encrypt or decrypt your code!",
        "/crypto now uses a better source for more accurate crypto data",
        "/joke has a new joke source for new jokes!",
        "/meme now has a new source for fresh memes!",
        "/stock has a nicer interface"
      ],
      "Small Changes": [
        "/card now gives you a card emoji thing",
        "/help command is nicer and easier to update (update part is for me lol)",
        "/minesweeper is more efficient and loads faster"
      ],
      "Removed Commands": [
        "Removed food command",
        "Removed music command",
        "Removed ping command",
        "Removed reddit command",
        "Removed say command",
        "Removed search command (might add /ai search in the future)",
        "Removed time command"
      ],
      "Bug Fixes": [
        "Fixed ~22 bugs that can crash Useless Bot",
        "Fixed too many smaller bugs that could cause skips and break stuff...",
        "Filter for some commands were not working now fixed"
      ],
      "Notes": [
        "AI commands now use a credit system and free users have 10 credits but voting will give an additional 90 credits for free! Also Premium users have unlimited credits!",
        "Everyone's save has been reset. Apologies for this but we had no choice as our old system is not compatable with our newer more efficient version!"
      ]
    }
  },
  {
    version: "I am too lazy to write more lol",
    date: "NA",
    sections: {

    }
  }
];

export default releaseNotes;  